/**
 * Production: print the Volugraph triangle once, then silence console noise from our code
 * and dependencies so the browser console stays clean (except this branding line).
 * Development and test builds are unchanged.
 *
 * Note: This does not hide hostnames or regions from DevTools → Network (every XHR/WebSocket
 * shows the URL) or from minified bundle strings. That is normal; security is auth, rules, and CORS.
 */
if (process.env.NODE_ENV === 'production' && typeof console !== 'undefined') {
  const noop = () => {};
  const isShopifyEmbed =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/shopify/');

  if (!isShopifyEmbed) {
    const out = console.log.bind(console);
    const ascii = [
      '',
      '        /\\',
      '       /  \\',
      '      /    \\',
      '     /______\\',
      '    Volugraph · 3D capture studio',
      '',
    ].join('\n');
    out(ascii);
  }

  const silent = [
    'log',
    'debug',
    'info',
    'trace',
    'dir',
    'dirxml',
    'table',
    'group',
    'groupCollapsed',
    'groupEnd',
    'time',
    'timeLog',
    'timeEnd',
    'profile',
    'profileEnd',
    'count',
    'assert',
    'clear',
  ];

  for (const key of silent) {
    if (typeof console[key] === 'function') {
      console[key] = noop;
    }
  }
}
